.root {
  min-width: 100px;
}

.inputRow {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  background-color: var(--tuna-palette-action-selected);
}

.chipRemove {
  cursor: pointer;
  font-weight: var(--tuna-typography-fontWeight-bold);
}

.filterInput {
  min-width: 120px;
  flex: 1;
}

.listbox {
  list-style: none;
  padding: 4px;
  margin: 0;
  max-height: 200px;
  overflow: auto;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: 4px;
  margin-top: 4px;
}

.option {
  padding: 4px 8px;
  cursor: pointer;
  font-size: 13px;
  border-radius: 4px;
}
